module.exports = __webpack_public_path__ + "static/media/activated_img.5f91a176.png";